export default {
  "content": "<path d=\"M13 19v-6h6v-2h-6V5h-2v6H5v2h6v6h2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};